// export constants
export const API_URL =
  process.env.REACT_APP_SERVER_API_URL || window.env?.REACT_APP_SERVER_API_URL;
